module.exports = __webpack_public_path__ + "static/media/logo.dd7fe053.png";